import { Box, BoxProps, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  SidebarItem,
  sidebarListBuyer,
  sidebarListReseller,
  sidebarListSupplier,
} from "../../constants/sidebarList";
import { useDividerColor } from "../../themes/colors";
import { getCurrentActiveUser } from "../../utils/helperFunction";
import { SidebarButton } from "../button/SidebarButton";

interface Props extends BoxProps {}

export const MenuDashboardDrawer = ({ ...rest }: Props) => {
  const dividerColor = useDividerColor();
  const [pageRoot, setPageRoot] = useState<string>("");
  const [menu, setMenu] = useState<SidebarItem[] | undefined>(undefined);

  useEffect(() => {
    const currentUser = getCurrentActiveUser();

    switch (currentUser.role) {
      case "buyer":
        setMenu(sidebarListBuyer);
        setPageRoot("/buyer");
        break;
      case "reseller":
        setMenu(sidebarListReseller);
        setPageRoot("/reseller");
        break;
      case "supplier":
        setMenu(sidebarListSupplier);
        setPageRoot("/supplier");
        break;
      default:
        setMenu(undefined);
    }
  }, []);

  return (
    <Box
      mt={6}
      pb={6}
      borderBottomWidth={"1px"}
      borderBottomColor={dividerColor}
      {...rest}
    >
      <Text textStyle={"b-sm-sb"} variant={"secondary"}>
        DASHBOARD
      </Text>

      <VStack gap={2} alignItems={"start"} mt={"18px"}>
        {menu &&
          menu.map((navItem, index) => (
            <SidebarButton
              key={navItem.id}
              to={navItem.to}
              end={navItem.to === pageRoot}
              isDrawer={true}
              px={0}
              _hover={{ bgColor: undefined }}
            >
              <HStack h={"20px"} whiteSpace={"nowrap"} alignItems={"center"}>
                <Icon
                  as={navItem.icon}
                  w={"100%"}
                  maxW={"16px"}
                  fontSize={[12, null, 14]}
                />

                <Text fontSize={[10, null, 12]} fontWeight={"semibold"}>
                  {navItem.name}
                </Text>
              </HStack>
            </SidebarButton>
          ))}
      </VStack>
    </Box>
  );
};
